import React, { useState, useEffect } from 'react';
import BlogCard from './BlogCard';
import blogPosts from '../data/blogData';
import SeoHelmet from "../components/SeoHelmet";
import { Link } from 'react-router-dom';

import extra from "../assets/img/blog/extra.png";
import Clip from "../assets/img/blog/Clip.png";
import Blog1 from "../assets/img/blog/blog1.png";
import Blog2 from "../assets/img/blog/blog2.png";
import Insta from "../assets/img/blog/insta.png";
import Arrow from "../assets/img/blog/arrow.png";
import Pagiarrow from "../assets/img/pagiarrow.png";

const Blog = () => {

  /* ---------------- TOP SLIDER STATE ---------------- */
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = blogPosts.length;

  const nextSlide = () => {
    setCurrentSlide(prev => (prev === totalSlides - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide(prev => (prev === 0 ? totalSlides - 1 : prev - 1));
  };

  /* ---------------- GRID PAGINATION ---------------- */
  const postsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(blogPosts.length / postsPerPage);
  const startIdx = (currentPage - 1) * postsPerPage;
  const selectedPosts = blogPosts.slice(startIdx, startIdx + postsPerPage);
  

  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const chunkedPosts = chunkArray(selectedPosts, 3);

  useEffect(() => {
    document.body.classList.add('blogmbr');
    return () => document.body.classList.remove('blogmbr');
  }, []);

  const slidePost = blogPosts[currentSlide];

  return (
    <>
        <SeoHelmet
  title="Confidence & Style Blog by Bhavana Singh"
  description="Read blogs by Bhavana Singh on confidence building, personal style, mindset, and self-growth with practical tips you can apply in daily life."
  
/>

      <section className='blog_part'>

        {/* ---------- HEADER ---------- */}
        <div className='border_mbr blog_bar'></div>
        <div className='blog_content'>
          <img src={extra} className='extraimg' alt="" />
          <div className='border_mbr'></div>
          <h2>New Blog</h2>
        </div>

        <div className='discover_text'>
          <div className='border_mbrr'></div>
          <h3>
            <img src={Clip} alt="" />
            DISCOVER BHAVNA’S NEWEST COLLECTOR EDITION ACCESORIES
            <img src={Clip} alt="" />
          </h3>
          <div className='border_mbrb'></div>
        </div>

        {/* ---------- TOP SLIDER ---------- */}
        <div className='blog_part_content'>
          <div className='blog_left'>
            <h3>Launching December 2026</h3>
            <p>{slidePost.excerpt}</p>
            <div className='border_mbrb'></div>
          </div>

          <div className='blog_imgma'>
            <img className='about_icon' src={slidePost.image || Blog1} alt="" />
            <img className='about_icon1' src={Blog2} alt="" />
            <Link to={`/${slidePost.link}`} className="read_more">
Read more<span className='mbr_arrow'>↗</span></Link>
          </div>

          <div className='blog_right'>
            <p>{slidePost.excerptright}</p>
            <h3>Don't Miss Out & Stay Updated</h3>
            <div className='border_mbrb'></div>
          </div>
        </div>

        {/* ---------- SLIDER PAGINATION ---------- */}
        <div className="blog_slider_pagination">
          <button className='pr_arrow' onClick={prevSlide}><img src={Pagiarrow}></img></button>

          {blogPosts.map((_, i) => (
            <span
              key={i}
              className={i === currentSlide ? 'active' : ''}
              onClick={() => setCurrentSlide(i)}
            >
              {i + 1}
            </span>
          ))}

          <button className='next_arrow' onClick={nextSlide}><img src={Pagiarrow}></img></button>
        </div>

        {/* ---------- INSTA CTA ---------- */}
        {/* <div className='discover_text dicinstat'>
          <h3>
            <img src={Arrow} alt="" />
            <span>
              More Contant At
              <img src={Insta} className='instabhav' alt="" />
              Bhavna555
            </span>
            <img src={Arrow} alt="" />
          </h3>
        </div> */}

        {/* ---------- BLOG GRID ---------- */}
       

      </section>
    </>
  );
};

export default Blog;
